import {
  T,
  always,
  any,
  cond,
  either,
  equals,
  pipe,
  prop,
  test as regexTest,
} from 'ramda'

// isMobileViewport :: Window -> Boolean
export const isMobileViewport = window => 480 >= window.outerWidth

// isSmallViewport :: Window -> Boolean
export const isSmallViewport = window => 600 >= window.innerWidth

// isWebView :: Object -> Boolean
export const isWebView = pipe(
  prop('pathname'),
  either(
    regexTest(/webview/),
    regexTest(/live-shows/),
  ),
)

// isIsraelAtWarCategory :: Number -> Boolean
export const isIsraelAtWarCategory = id => any(equals(id))([269, 271, 273, 321])

// shouldDisplayMissingPersonList :: String -> Boolean
export const shouldDisplayMissingPersonList = slug => any(
  equals(slug.toLowerCase()),
)([
  // en slug
  '1699539583-not-just-a-number-the-names-and-faces-of-the-239-israelis-abducted-to-gaza',
  // fr slug
  '1699539742-les-239-personnes-enlevees-a-gaza-ont-un-visage-et-un-nom',
  // ar slug
  '1699539877-ليس-مجرد-رقم-أسماء-ووجوه-239-إسرائيلي-ا-اختطفوا-في-غزة',
])
